const TEMPLATE_STORAGE_KEY='amp-event-templates';

function readTemplates(){
  try{
    const stored=localStorage.getItem(TEMPLATE_STORAGE_KEY);
    return stored?JSON.parse(stored):[];
  }catch{
    return[];
  }
}

export function saveEventTemplate(event){
  const templates=readTemplates();

  const template={
    id:`template-${Date.now()}`,
    name:event.name||'Untitled event template',
    createdAt:new Date().toISOString(),
    sourceEventId:event.id,
    event:{
      name:event.name||'',
      client:event.client||'',
      email:event.email||'',
      phone:event.phone||'',
      type:event.type||'Wedding',
      date:event.date||'',
      venue:event.venue||'',
      guests:event.guests||'',
      dj:event.dj||'',
      eventDuration:event.eventDuration||'',
      eventStartTime:event.eventStartTime||'',
      setupStartTime:event.setupStartTime||'',
      eventEndTime:event.eventEndTime||'',
      services:Array.isArray(event.services)
        ?[...event.services]
        :[],
      serviceDetails:event.serviceDetails||''
    }
  };

  localStorage.setItem(
    TEMPLATE_STORAGE_KEY,
    JSON.stringify([template,...templates])
  );

  return template;
}

export function getEventTemplates(){
  return readTemplates();
}

export function updateEventTemplate(templateId,event){
  const templates=readTemplates().map((template)=>{
    if(template.id!==templateId){
      return template;
    }

    const updatedEvent={
      ...template.event,
      ...event,
      services:Array.isArray(event.services)
        ?[...event.services]
        :[]
    };

    return{
      ...template,
      name:updatedEvent.name||template.name||'Untitled event template',
      updatedAt:new Date().toISOString(),
      event:updatedEvent
    };
  });

  localStorage.setItem(
    TEMPLATE_STORAGE_KEY,
    JSON.stringify(templates)
  );

  return templates.find((template)=>template.id===templateId)||null;
}

export function deleteEventTemplate(templateId){
  const templates=readTemplates().filter(
    (template)=>template.id!==templateId
  );

  localStorage.setItem(
    TEMPLATE_STORAGE_KEY,
    JSON.stringify(templates)
  );
}